import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class PjsipService extends ServiceCRUD {
  constructor() {
    super('/api/pjsip-configurations');
  }
}

export default new PjsipService();
